import dynamicfunction from '../../../../utils/dynamicfunction';
import { cn } from '../../../../utils/utils';

const ErrorText = ({ text = '', numbers, className = '', isCenter = false }) => {
  const { TextWeight, TextAlign } = dynamicfunction();

  if (!text) return null;

  return (
    <span className={cn('text-red text-xs mt-1', TextWeight.light, isCenter ? 'text-center' : TextAlign, className)}>
      {text} {numbers}
    </span>
  );
};

export default ErrorText;
